export default "__VITE_ASSET__DPQt6lyJ__"